module.exports = __webpack_public_path__ + "img/367.436f9519.jpg";